import { createFormStore } from '#/shared/stores/createFormStore';

import type { ForwardRequestFormValues } from '../types/ForwardRequestFormValues';

export const useForwardFormStore = createFormStore<ForwardRequestFormValues>('forward-form-storage');
